const Button = {
  baseStyle: {
    borderRadius: "8px",
    fontWeight: 600,
    fontFamily: "'Noto Sans JP', sans-serif",
  },
  variants: {
    solid: {
      bg: "#FF6600",
      color: "white",
      _hover: {
        bgGradient: "linear(to-r, #FF8533, #E65C00)",
        boxShadow: "0 8px 32px rgba(255, 102, 0, 0.3)",
        transform: "translateY(-2px)",
      },
    },
  },
};
export default Button;
